<template>
  <div class="page-container">
    <!-- 面包屑 - 移动端隐藏 -->
    <el-breadcrumb separator-icon="ArrowRight" class="breadcrumb hide-on-mobile">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>学员列表</el-breadcrumb-item>
    </el-breadcrumb>
    
    <el-card class="main-card">
      <!-- 功能区 -->
      <div class="toolbar">
        <!-- 搜索区 -->
        <div class="search-area">
          <el-input v-model="search" clearable placeholder="姓名" prefix-icon="Search" class="search-input" />
          <el-input v-model="searchPhone" clearable placeholder="手机号" prefix-icon="Phone" class="search-input" />
          <el-input v-model="searchUnit" clearable placeholder="单位" prefix-icon="OfficeBuilding" class="search-input hide-on-mobile" />
          <el-select v-model="searchClass" clearable placeholder="班级" class="search-input hide-on-mobile" @change="handleSearch">
            <el-option v-for="item in classOptions" :key="item.id" :label="item.className" :value="item.className" />
          </el-select>
          <el-button icon="Search" type="primary" @click="handleSearch" class="search-btn">查询</el-button>
          <el-button icon="RefreshLeft" type="default" @click="reset" class="search-btn">重置</el-button>
        </div>
        <!-- 操作按钮 -->
        <div class="action-area">
          <el-tooltip content="导入学员" placement="top">
            <el-button icon="Upload" type="warning" @click="handleImportStudent" class="action-btn">导入</el-button>
          </el-tooltip>
          <el-tooltip content="导出学员" placement="top">
            <el-button icon="Download" type="success" @click="handleExport" class="action-btn">导出</el-button>
          </el-tooltip>
          <el-tooltip content="添加" placement="top">
            <el-button icon="Plus" type="primary" @click="add" class="action-btn">添加</el-button>
          </el-tooltip>
        </div>
      </div>
      
      <!-- PC端表格 -->
      <el-table 
        v-loading="loading" 
        :data="tableData" 
        border 
        stripe
        class="pc-table"
        style="width: 100%"
      >
        <el-table-column label="#" type="index" width="50" />
        <el-table-column label="学号" prop="username" sortable />
        <el-table-column label="姓名" prop="name" />
        <el-table-column label="性别" prop="gender" class-name="hidden-mobile" />
        <el-table-column label="年龄" prop="age" class-name="hidden-mobile" />
        <el-table-column label="手机号" prop="phoneNum" />
        <el-table-column label="邮箱" prop="email" show-overflow-tooltip class-name="hidden-mobile" />
        <el-table-column label="单位" prop="unit" class-name="hidden-mobile" />
        <el-table-column label="班级" prop="classNum" class-name="hidden-mobile" />
        <el-table-column label="入住宿舍" width="120">
          <template #default="scope">
            <span v-if="scope.row.dormRoom">{{ scope.row.dormRoom.dormBuildId + '-' + scope.row.dormRoom.dormRoomId }}</span>
            <span v-else style="color: #999">未安排</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="scope">
            <el-button icon="Edit" type="primary" size="small" @click="handleEdit(scope.row)"></el-button>
            <el-popconfirm title="确认删除？" @confirm="handleDelete(scope.row.username)">
              <template #reference>
                <el-button icon="Delete" type="danger" size="small"></el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 移动端卡片列表 -->
      <div class="mobile-card-list" v-loading="loading">
        <div v-for="item in tableData" :key="item.username" class="card-item">
          <div class="card-row">
            <span class="card-label">学号:</span>
            <span class="card-value">{{ item.username }}</span>
          </div>
          <div class="card-row">
            <span class="card-label">姓名:</span>
            <span class="card-value">{{ item.name }}</span>
          </div>
          <div class="card-row">
            <span class="card-label">手机号:</span>
            <span class="card-value">{{ item.phoneNum }}</span>
          </div>
          <div class="card-row">
            <span class="card-label">入住宿舍:</span>
            <span class="card-value">
              {{ item.dormRoom ? (item.dormRoom.dormBuildId + '-' + item.dormRoom.dormRoomId) : '未安排' }}
            </span>
          </div>
          <div class="card-actions">
            <el-button icon="Edit" type="primary" size="small" @click="handleEdit(item)">编辑</el-button>
            <el-popconfirm title="确认删除？" @confirm="handleDelete(item.username)">
              <template #reference>
                <el-button icon="Delete" type="danger" size="small">删除</el-button>
              </template>
            </el-popconfirm>
          </div>
        </div>
      </div>
      
      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :page-sizes="[10, 20]" :total="total"
          layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
      
      <!-- 弹窗 -->
      <el-dialog v-model="dialogVisible" title="操作" width="30%" class="responsive-dialog" @close="cancel">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" class="responsive-form">
          <el-form-item label="学号" prop="username" v-if="judgeAddOrEdit">
            <el-input v-model="form.username" disabled style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" v-if="judgeAddOrEdit">
            <el-input v-model="form.password" :disabled="disabled" show-password style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="年龄" prop="age">
            <el-input v-model.number="form.age" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-radio-group v-model="form.gender">
              <el-radio value="男">男</el-radio>
              <el-radio value="女">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手机号" prop="phoneNum">
            <el-input v-model="form.phoneNum" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="单位">
            <el-input v-model="form.unit" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="班级">
            <el-select v-model="form.classNum" placeholder="请选择班级" style="width: 80%" clearable filterable>
              <el-option v-for="item in classOptions" :key="item.id" :label="item.className" :value="item.className"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="save">确定</el-button>
          </span>
        </template>
      </el-dialog>

      <!-- 导入学员对话框 -->
      <el-dialog title="导入学员信息" v-model="importDialogVisible" width="400px" :close-on-click-modal="false">
        <el-upload
          ref="importUploadRef"
          action="/execl/importStudents"
          :headers="uploadHeaders"
          :auto-upload="false"
          :limit="1"
          accept=".xlsx,.xls"
          :on-success="handleImportSuccess"
          :on-error="handleImportError"
        >
          <template #trigger>
            <el-button type="primary">选择文件</el-button>
          </template>
          <template #tip>
            <div class="el-upload__tip">
              只能上传 xlsx/xls 文件，
              <el-link type="primary" :underline="false" @click="downloadStudentTemplate">下载导入模板</el-link>
            </div>
          </template>
        </el-upload>
        <template #footer>
          <el-button @click="importDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitImport">确认导入</el-button>
        </template>
      </el-dialog>
    </el-card>
  </div>
</template>
<script src="@/assets/js/StuInfo.js"></script>
<style scoped>
.page-container {
  padding: 0;
}

.breadcrumb {
  margin: 15px;
}

.main-card {
  margin: 15px;
  min-height: calc(100vh - 111px);
}

/* 工具栏 */
.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
  align-items: center;
}

.search-area {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.search-input {
  width: 180px;
}

.search-btn {
  margin-left: 5px;
}

.action-area {
  display: flex;
  gap: 8px;
}

/* PC端表格 */
.pc-table {
  width: 100%;
}

/* 移动端卡片列表 */
.mobile-card-list {
  display: none;
}

.card-item {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
}

.card-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;
}

.card-row:last-of-type {
  border-bottom: none;
}

.card-label {
  color: #909399;
  font-size: 13px;
}

.card-value {
  color: #303133;
  font-size: 13px;
}

.card-actions {
  margin-top: 10px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

/* 分页 */
.pagination-wrapper {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

/* 响应式设计 */
@media screen and (max-width: 767px) {
  .breadcrumb {
    margin: 10px;
  }
  
  .main-card {
    margin: 10px;
    min-height: calc(100vh - 100px);
  }
  
  .toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  
  .search-area {
    flex-direction: column;
    width: 100%;
  }
  
  .search-input {
    width: 100%;
  }
  
  .search-btn {
    width: 50%;
    margin-left: 0;
  }
  
  .action-area {
    width: 100%;
    justify-content: flex-end;
    margin-top: 10px;
  }
  
  .action-btn {
    width: 80px;
  }
  
  /* 移动端显示卡片列表 */
  .pc-table {
    display: none;
  }
  
  .mobile-card-list {
    display: block;
  }
  
  /* 分页简化 */
  .pagination-wrapper .el-pagination {
    flex-wrap: wrap;
  }
  
  /* 弹窗响应式 */
  .responsive-dialog {
    width: 95% !important;
  }
  
  .responsive-form .el-form-item__label {
    width: 80px !important;
  }
  
  .responsive-form .el-input {
    width: 100% !important;
  }
}

@media screen and (max-width: 479px) {
  .hide-on-mobile {
    display: none !important;
  }
  
  .card-item {
    padding: 10px;
  }
  
  .card-label, .card-value {
    font-size: 12px;
  }
}

/* 隐藏移动端 */
@media screen and (max-width: 767px) {
  .hide-on-mobile {
    display: none !important;
  }
}
</style>